
<section v-if="card.notes" class="card-profile-collection-notes">
  <h4 class="secondary-font">
    Notes
  </h4>

  <p>{{ card.notes }}</p>
</section>
